import { render, staticRenderFns } from "./NameForm.vue?vue&type=template&id=cb50946c&scoped=true"
import script from "./NameForm.vue?vue&type=script&lang=js"
export * from "./NameForm.vue?vue&type=script&lang=js"
import style0 from "./NameForm.vue?vue&type=style&index=0&id=cb50946c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb50946c",
  null
  
)

export default component.exports